import React, { Component } from 'react';
import ButtonWithIcon from '../../../../Elements/ButtonWithIcon';
import OverWindow from '../../../../Elements/OverWindow';
import Loading from '../../../../Elements/loading';
import ColButton from '../../../../Elements/ColButton';
import { List, ListItem, ListItemText } from '@mui/material';
import MetaService from '../../../../Services/MetaService';
import ErrorMessage from '../../../../Elements/ErrorMessage';

export default class MetaOperation extends Component
{
    constructor (props)
    {
        super(props);
        this.state =
        {
            loading: true,
            ConvertedResult: [],
            selectedIndexInSource: -1,
            selectedIndexInDest: -1,
            saving: false,
            metaData:
            {
                TemplateId: props.ReportTemplateId,
                SelectedMetaIds: []
            }
        };

    }

    componentDidMount ()
    {
        MetaService.GetAvailableMetaData(this.props.ReportTemplateId)
            .then((result) =>
            {
                const ConvertedResult = MetaService.ConvertDBMetaList(result);
                ConvertedResult.forEach(element => element.SelectedInList = false);
                this.setState(
                    {
                        ConvertedResult,
                        loading: false,
                        selectedIndexInSource: ConvertedResult.indexOf(ConvertedResult.find(emp => emp.SelectedInList === false))
                    });
            })
            .catch(() => ErrorMessage.SetErrorMessage("MO40"));
    }

    moveAllMetaToOrFromDestination (selected)
    {
        const tempConvertedResult = this.state.ConvertedResult;
        tempConvertedResult.forEach(mt => mt.SelectedInList = selected);
        const newSelectedIndexInSource = this.state.ConvertedResult.indexOf(this.state.ConvertedResult.find(emp => emp.SelectedInList === false));
        const newSelectedIndexInDest = this.state.ConvertedResult.indexOf(this.state.ConvertedResult.find(emp => emp.SelectedInList === true));
        this.setState({
            ConvertedResult: tempConvertedResult,
            selectedIndexInSource: newSelectedIndexInSource,
            selectedIndexInDest: newSelectedIndexInDest,
        });
    }

    moveMetaToOrFromDestination (index, selected)
    {
        if (index === -1)
        {
            return;
        }
        const tempConvertedResult = this.state.ConvertedResult;
        tempConvertedResult[ index ].SelectedInList = selected;
        const newSelectedIndexInSource = this.state.ConvertedResult.indexOf(this.state.ConvertedResult.find(emp => emp.SelectedInList === false));
        const newSelectedIndexInDest = this.state.ConvertedResult.indexOf(this.state.ConvertedResult.find(emp => emp.SelectedInList === true));
        this.setState({
            ConvertedResult: tempConvertedResult,
            selectedIndexInSource: selected ? newSelectedIndexInSource : index,
            selectedIndexInDest: selected ? index : newSelectedIndexInDest,
        });
    }

    renderListButtons ()
    {
        const buttonClassName = "btn btn-sm m-1 w-100";
        return (
            <div className="align-self-center verticallyAlignedDiv">
                <div>
                    <ButtonWithIcon
                        className={`${buttonClassName} btn-info`}
                        type="button"
                        value="Add All"
                        onClick={() => this.moveAllMetaToOrFromDestination(true)}
                        key="keyChevronAddAll"
                        iconName="fa-solid fa-angles-right"
                    />
                </div>
                <div>
                    <ButtonWithIcon
                        className={`${buttonClassName} ${this.state.selectedIndexInSource === -1 ? "btn-secondary" : "btn-info"}`}
                        type="button"
                        value={""}
                        onClick={() => this.moveMetaToOrFromDestination(this.state.selectedIndexInSource, true)}
                        key="keyChevronAdd"
                        iconName="fa-solid fa-angle-right"
                    />
                </div>
                <div>
                    <ButtonWithIcon
                        className={`${buttonClassName} ${this.state.selectedIndexInDest === -1 ? "btn-secondary" : "btn-info"}`}
                        type="button"
                        value={""}
                        onClick={() => this.moveMetaToOrFromDestination(this.state.selectedIndexInDest, false)}
                        key="keyChevronRemove"
                        iconName="fa-solid fa-angle-left"
                    />
                </div>

                <div>
                    <ButtonWithIcon
                        className={`${buttonClassName} btn-info`}
                        type="button"
                        value="Remove All"
                        onClick={() => this.moveAllMetaToOrFromDestination(false)}
                        key="keyChevronRemoveAll"
                        iconName="fa-solid fa-angles-left"
                    />
                </div>

            </div>
        );
    }

    handleListItemClickInSource (e, index)
    {
        this.setState({ selectedIndexInSource: index });
    }

    handleListItemClickInDest (e, index)
    {
        this.setState({ selectedIndexInDest: index });
    }

    renderSourceList ()
    {
        return (<div className="p-1 m-1">
            <p className="text-center">Meta</p>
            <List
                className="hugefixedHeightList"
                dense={true}
                component="div"
                role="list"
            >
                {this.state.ConvertedResult.map((e, index) =>
                {
                    return e.SelectedInList ? null : (
                        <ListItem
                            key={`lik${index}`}
                            button
                            selected={this.state.selectedIndexInSource === index}
                            onClick={(e) => this.handleListItemClickInSource(e, index)}
                        >
                            <ListItemText primary={e.DisplayName} />
                        </ListItem>
                    );
                })}
            </List>
        </div>);
    }

    renderDestList ()
    {
        return (
            <div className="p-1 m-1">
                <p className="text-center">Selected Meta</p>
                <List
                    className="hugefixedHeightList"
                    dense={true}
                    component="div"
                    role="list"
                >
                    {this.state.ConvertedResult.map((e, index) =>
                    {
                        return e.SelectedInList ? (
                            <ListItem
                                key={`lik${index}`}
                                button
                                selected={this.state.selectedIndexInSource === index}
                                onClick={(e) => this.handleListItemClickInDest(e, index)}
                            >
                                <ListItemText primary={e.DisplayName} />
                            </ListItem>
                        ) : null;
                    })}
                </List>
            </div>);
    }

    validityCheckerForTheEntireForm ()
    {
        return this.validityCheckerForSelectedMetas() === "";
    }

    validityCheckerForSelectedMetas ()
    {
        if (!this.state.ConvertedResult) return "You have to select at least one meta!";
        const selected = this.state.ConvertedResult.find(emp => emp.SelectedInList === true);
        if (selected) return "";
        return "You have to select at least one meta!";
    }

    renderCancelAndSubmitButtons ()
    {
        return (
            <div className="container-fluid  m-1 p-1">
                <div className="row">
                    <ColButton
                        text="Cancel"
                        onClick={() => this.props.clickOnCancel(false)}
                        disabled={this.state.saving}
                    />
                    <ColButton
                        text="Apply Metas"
                        type="submit"
                        icon={`fa-solid fa-upload${this.state.saving ? " fa-spin" : ""}`}
                        disabled={this.state.saving || !this.validityCheckerForTheEntireForm()}
                    />
                </div>
            </div>
        );
    }

    handleOnSubmit ()
    {
        const selectedMeta = { ...this.state.metaData };
        selectedMeta.SelectedMetaIds = [];
        this.state.ConvertedResult.forEach(emp =>
        {
            if (emp.SelectedInList)
            {
                selectedMeta.SelectedMetaIds.push(emp.MetaId);
            }
        });
        MetaService.AddNewMeta(selectedMeta)
            .then(result => this.props.clickOnCancel(true))
            .catch(error =>
            {
                ErrorMessage.SetErrorMessage("Error! ErrorCode: MO246");
                this.setState({ saving: false });
            });

    }

    rendelMetaList ()
    {
        //style={{maxHeight:"60vh"}}
        return (
            <div className="container-fluid  border rounded m-1 p-1 " >
                <h6>Apply meta fee</h6>
                <div className="row">
                    <div className="col-1" />
                    <div className="col-4">{this.renderSourceList()}</div>
                    <div className="col-2">{this.renderListButtons()}</div>
                    <div className="col-4">{this.renderDestList()}</div>
                    <div className="col-1" />
                </div>
            </div>
        );
    }

    render ()
    {
        return (
            <OverWindow
                clickOnCancel={() =>
                {
                    if (!this.state.saving) this.props.clickOnCancel(false);
                }}
                title={"Apply meta"}
                closeOnClickOutside={false}
                iconName="fa-solid fa-plus-circle"
                minHeight={600}
            >
                <form
                    onSubmit={(e) =>
                    {
                        e.preventDefault();
                        this.handleOnSubmit();
                    }}
                >
                    <div className=" p-1 m-1">
                        {
                            this.state.loading
                                ? <Loading />
                                : this.rendelMetaList()
                        }
                        {this.renderCancelAndSubmitButtons()}
                    </div>
                </form>
            </OverWindow>
        );
    }
}
